import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'fcpr-fees',
    templateUrl: './fcpr-fees.component.html',
    styleUrls: ['./fcpr-fees.component.scss'],
    standalone: false
})
export class FcprFeesComponent extends EaSubscriptionBuilder implements OnInit {
  parameters;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    this.parameters = pledge?.parameters;

    this.subscriptionFacade.initForm(this, { ...this.parameters });
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
